export default function(h, row, index) {
    if ((row.email_correct === row.email) || (!row.email) || (row.email === null))
        return <span class="orders_table__contacts">{row.email_correct}</span>
    else
        return <span><span class="orders_table__contacts">{row.email_correct}</span><br/><span class="orders_table__contacts">({row.email})</span></span>
}